import * as React from 'react';
import ErrorPageLayout from './ErrorPageLayout';
import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useKeycloakContext } from '@common/context/keycloakContext';

const ErrorPage: React.FC = () => {
  const { isAuthenticated } = useKeycloakContext();

  const link = isAuthenticated ? '/user/dashboard' : '/';
  const linkText = isAuthenticated ? 'dashboard' : 'home';

  return (
    <ErrorPageLayout
      disableImage
      header="OOPS! SOMETHING WENT WRONG."
      subtext={
        <>
          You might want to double check how you got here, or head{' '}
          {isAuthenticated && <>back to your </>}
          <Link
            data-testid="error-page-link"
            component={RouterLink}
            to={link}
            underline="none"
          >
            {linkText}
          </Link>
          .
        </>
      }
    />
  );
};

export default ErrorPage;
